import React, {
  useEffect,
} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { GTMTracking } from '@common/ui/general';

import {
  setIsProfileSidebarModalOpen,
} from '@alumni_v2/stores/reviews/actions';

import arrowIcon from '@alumni_v2/images/svg/arrow.svg';
import bagIcon from '@alumni_v2/images/svg/bagIcon.svg';
import frame from '@alumni_v2/images/webp/frame.webp';
import locationIcon from '@alumni_v2/images/svg/location.svg';
import rightArrow from '@alumni_v2/images/svg/rightArrow.svg';
import upArrowIcon from '@alumni_v2/images/svg/upArrowIcon.svg';
import ratingIcon from '@alumni_v2/images/svg/star.svg';

import AlumniConnectButton from './AlumniConnectButton';
import AsqQnAButton from './AsqQnAButton';

import styles from './Card.module.scss';

function Card({
  name,
  profileImg,
  designation,
  location,
  preScalerText,
  preScalerImg,
  postScalerText,
  postScalerImg,
  salaryHike,
  availableForQnA,
  onQnAClick,
  userId,
  rating = 0,
  forceOpen = false,
  setSidebarModalStage,
  setIsModalOpen,
  isModalOpen,
  setSidebarOpenProfile,
}) {
  const dispatch = useDispatch();
  const { showAlumniConnect } = window.__INITIAL_STATE__;

  const handleCardClick = () => {
    if (showAlumniConnect) {
      setSidebarModalStage(0);
      setIsModalOpen(true);
      setSidebarOpenProfile(userId);
    } else {
      setIsModalOpen(true);
    }
  };

  useEffect(() => {
    if (forceOpen) {
      setIsModalOpen(true);
    }
  }, [dispatch, forceOpen, setIsModalOpen]);


  useEffect(() => {
    if (isModalOpen) {
      dispatch(setIsProfileSidebarModalOpen(true));
    }
  }, [dispatch, isModalOpen]);

  return (
    <>
      <div
        className={styles.card}
      >
        <GTMTracking
          component="div"
          gtmEventType="cta"
          gtmEventAction="click"
          gtmEventResult="card_details_open"
          gtmEventCategory="alumni_directory"
          onClick={handleCardClick}
          role="button"
          tabIndex={0}
          className={styles.topContainer}
          gtmEventData={{
            click_text: name,
            click_type: 'card_details_open',
          }}
        >
          <div className={styles.alumniDetails}>
            {availableForQnA ? (
              <div className={styles.backProfileImg}>
                <img
                  className={styles.profileImg}
                  src={profileImg}
                  alt="ProfileImg"
                />
                <img
                  className={styles.profileImgAlt}
                  src={frame}
                  alt="ProfileImg"
                />
              </div>
            ) : (
              <div className={styles.alumniImg}>
                <img src={profileImg} alt="ProfileImg" />
              </div>
            )}

            <div className={styles.profileDetails}>

              <div className={styles.name}>{name}</div>

              <div className={styles.info}>
                <img src={bagIcon} alt="bagIcon" />
                <div className={styles.text}>{designation}</div>
              </div>

              <div className={styles.info}>
                <img src={locationIcon} alt="locationIcon" />
                <div className={styles.text}>{location}</div>
              </div>
              {rating > 0 && (
                <div>
                  {Array.from({ length: 5 }, (_, i) => (
                    <img
                      src={ratingIcon}
                      className={classNames(
                        styles.rating,
                        { [styles.highlight]: (i + 1 <= Math.ceil(rating)) },
                      )}
                      key={i}
                      alt="ratingIcon"
                    />
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className={styles.professionalDetails}>
            <div className={styles.transitionInfo}>
              <div className={styles.companyInfo}>
                <div className={styles.text}>Pre Scaler</div>

                <div className={styles.companyLogo}>
                  {preScalerImg ? (
                    <img src={preScalerImg} alt="preScaler Company" />
                  ) : (
                    <div className={styles.companyName}>
                      {preScalerText}
                    </div>
                  )}
                </div>
              </div>

              <div className={styles.arrowIndicator}>
                <img src={arrowIcon} alt="to" />
              </div>

              <div className={styles.companyInfo}>
                <div className={styles.text}>Post Scaler</div>

                <div className={styles.companyLogo}>
                  {postScalerImg ? (
                    <div className={styles.companyImg}>
                      <img
                        // For specifically bigger logos we are adding extra
                        // class to reduce the size.
                        className={
                          (postScalerImg.includes('1662719768')
                          || postScalerImg.includes('1665564135'))
                          && styles.bigImage
                        }
                        src={postScalerImg}
                        alt="postScaler Company"
                      />
                    </div>
                  ) : (
                    <div className={styles.companyName}>
                      {postScalerText}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className={styles.hikeContainer}>
            {salaryHike ? (
              <div className={styles.hikeInfo}>
                <div className={styles.hikeText}>
                  <img src={upArrowIcon} alt="up-arrow" />
                  <div>
                    {salaryHike}
                    % Salary Hike after Scaler
                  </div>
                </div>
              </div>
            ) : (
              <div className={styles.altHikeText}>
                <div>
                  Connect to know Salary Hike
                </div>
              </div>
            )}

          </div>
        </GTMTracking>

        <div className={styles.bottomContainer}>
          <div className={styles.qNa}>
            {showAlumniConnect
              ? (
                <AlumniConnectButton
                  name={name}
                  handleCardClick={handleCardClick}
                  availableForQnA={availableForQnA}
                />
              )
              : (
                <AsqQnAButton
                  name={name}
                  onQnAClick={onQnAClick}
                  availableForQnA={availableForQnA}
                />
              )}
          </div>

          <GTMTracking
            component="div"
            gtmEventType="cta"
            gtmEventAction="click"
            gtmEventResult="card_details_open"
            gtmEventCategory="alumni_directory"
            onClick={handleCardClick}
            role="button"
            tabIndex={0}
            className={styles.profileBtn}
            gtmEventData={{
              click_text: name,
              click_type: 'card_details_open',
            }}
          >
            <div className={styles.btnText}>View Profile</div>
            <img src={rightArrow} alt="right-arrow" />
          </GTMTracking>
        </div>
      </div>
    </>
  );
}

Card.propTypes = {
  name: PropTypes.string.isRequired,
  profileImg: PropTypes.string.isRequired,
  designation: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  preScalerText: PropTypes.string.isRequired,
  preScalerImg: PropTypes.string,
  postScalerText: PropTypes.string.isRequired,
  postScalerImg: PropTypes.string.isRequired,
  salaryHike: PropTypes.number,
  availableForQnA: PropTypes.bool,
  onQnAClick: PropTypes.func,
  forceOpen: PropTypes.bool,
};

export default Card;
